'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var material = require('@mui/material');
var iconsMaterial = require('@mui/icons-material');
var lab = require('@mui/lab');
var reactCore = require('@patternfly/react-core');
var reactLogViewer = require('@patternfly/react-log-viewer');
var lodash = require('lodash');
require('@patternfly/react-core/dist/styles/base.css');
var moment = require('moment');
var colors = require('@mui/material/colors');
var styles$1 = require('@mui/styles');
var MoreVertIcon = require('@mui/icons-material/MoreVert');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var MoreVertIcon__default = /*#__PURE__*/_interopDefaultLegacy(MoreVertIcon);

function HelloWorld() {
  return /*#__PURE__*/React__default["default"].createElement("h1", null, "Hello World");
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

const Button = _ref => {
  let {
    size,
    primary,
    disabled,
    text,
    onClick,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("button", _extends({
    type: "button",
    onClick: onClick,
    primary: primary,
    disabled: disabled,
    size: size
  }, props), text);
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const LogsListAndSearch = props => {
  const {
    fileSearch,
    setFileSearch,
    filesToDisplay,
    selectedLogs,
    handleFileSelect,
    classes,
    filesHeading
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    alignItems: "flex-start",
    direction: "column",
    spacing: 2,
    sx: classes.filesDisplayBox,
    p: 2
  }, /*#__PURE__*/React__default["default"].createElement(material.TextField, {
    label: "Search",
    name: "FileSearch",
    value: fileSearch || '',
    size: "small",
    variant: "standard",
    onChange: e => setFileSearch(e.target.value),
    InputProps: {
      endAdornment: ( /*#__PURE__*/React__default["default"].createElement(material.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default["default"].createElement(iconsMaterial.Search, {
        color: "primary",
        fontSize: "small"
      })))
    }
  }), /*#__PURE__*/React__default["default"].createElement(material.Box, null, filesHeading && /*#__PURE__*/React__default["default"].createElement(material.Typography, {
    variant: "h6"
  }, filesHeading), /*#__PURE__*/React__default["default"].createElement(material.FormControl, {
    component: "fieldset",
    variant: "standard"
  }, /*#__PURE__*/React__default["default"].createElement(material.FormGroup, null, filesToDisplay === null || filesToDisplay === void 0 ? void 0 : filesToDisplay.map((f, i) => ( /*#__PURE__*/React__default["default"].createElement(material.FormControlLabel, {
    control: /*#__PURE__*/React__default["default"].createElement(material.Checkbox, {
      checked: selectedLogs === null || selectedLogs === void 0 ? void 0 : selectedLogs.includes(f),
      onChange: handleFileSelect,
      name: f
    }),
    label: f
  })))))));
};

const LoadingOverlay = props => {
  const {
    isLoading,
    children,
    showChildrenInBackground = false
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(material.Box, {
    position: "relative",
    height: "100%",
    width: "100%"
  }, isLoading ? ( /*#__PURE__*/React__default["default"].createElement(material.Box, {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    top: "50%",
    right: "50%"
  }, /*#__PURE__*/React__default["default"].createElement(material.CircularProgress, null))) : !showChildrenInBackground ? children : '', showChildrenInBackground ? children : '');
};

const LogsView = props => {
  const {
    selectedLogs,
    logFiles,
    isPollingEnabled,
    isPolling,
    goLive,
    entities,
    entityLabel,
    selectedEntity,
    setSelectedEntity,
    downloadFile,
    currentLog,
    setCurrentLog,
    removeFileFromViewList,
    isLogsLoading,
    logViewerRef,
    logText,
    hasLineNumbers,
    onScroll = lodash.noop,
    search,
    toggleLineNumbers,
    // * ---- components ---
    HeaderComponent,
    FilteredComponent,
    // * helper fns
    onChangeHandlerLogsSearching,
    onClearHandlerLogsSearching,
    classes
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(material.Box, {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    sx: {
      '--pf-c-log-viewer__text--PaddingLeft': '5px'
    },
    p: !selectedLogs.length ? 2 : 1
  }, !(selectedLogs === null || selectedLogs === void 0 ? void 0 : selectedLogs.length) ? (logFiles === null || logFiles === void 0 ? void 0 : logFiles.length) ? ( /*#__PURE__*/React__default["default"].createElement(material.Typography, {
    variant: "h5"
  }, "Select a file to see the corresponding logs.")) : ( /*#__PURE__*/React__default["default"].createElement(material.Typography, {
    variant: "h5"
  }, "No log files to select")) : ( /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    direction: "column"
  }, /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center",
    mx: 1,
    my: 0.5
  }, isPollingEnabled ? ( /*#__PURE__*/React__default["default"].createElement(material.Tooltip, {
    arrow: true,
    title: isPolling ? 'Fetching live logs every 15 secs' : 'Go Live to start fetching live logs',
    placement: "right"
  }, /*#__PURE__*/React__default["default"].createElement(material.Button, {
    color: "primary",
    startIcon: isPolling && /*#__PURE__*/React__default["default"].createElement(iconsMaterial.FiberManualRecord, {
      style: classes.liveLogs
    }),
    onClick: () => {
      if (!isPolling) {
        goLive();
      }
    }
  }, isPolling ? 'Live' : 'Go Live'))) : ( /*#__PURE__*/React__default["default"].createElement(material.Box, null)), /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    direction: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    spacing: 2,
    width: "60%"
  }, (entities === null || entities === void 0 ? void 0 : entities.length) > 1 && ( /*#__PURE__*/React__default["default"].createElement(material.TextField, {
    select: true,
    label: entityLabel,
    value: selectedEntity,
    variant: "standard",
    size: "small",
    sx: {
      width: '300px'
    },
    onChange: e => setSelectedEntity(e.target.value),
    name: "selectedNode"
  }, entities === null || entities === void 0 ? void 0 : entities.map(i => {
    return /*#__PURE__*/React__default["default"].createElement(material.MenuItem, {
      key: i._id,
      value: i._id
    }, i.name);
  }))), FilteredComponent && /*#__PURE__*/React__default["default"].createElement(FilteredComponent, null), /*#__PURE__*/React__default["default"].createElement(material.IconButton, {
    size: "small",
    color: "primary",
    onClick: () => downloadFile()
  }, /*#__PURE__*/React__default["default"].createElement(iconsMaterial.Download, {
    fontSize: "small"
  })))), /*#__PURE__*/React__default["default"].createElement(lab.TabContext, {
    value: currentLog
  }, /*#__PURE__*/React__default["default"].createElement(lab.TabList, {
    onChange: (e, v) => setCurrentLog(v),
    indicatorColor: "primary",
    variant: "scrollable"
  }, selectedLogs === null || selectedLogs === void 0 ? void 0 : selectedLogs.map(l => ( /*#__PURE__*/React__default["default"].createElement(material.Tab, {
    value: l,
    disableRipple: true,
    sx: classes.logsTab,
    label: /*#__PURE__*/React__default["default"].createElement("span", null, l, /*#__PURE__*/React__default["default"].createElement(material.IconButton, {
      size: "small",
      onClick: () => removeFileFromViewList(l),
      style: {
        color: currentLog === l ? '#11567F' : '#08080D'
      }
    }, /*#__PURE__*/React__default["default"].createElement(iconsMaterial.Close, {
      fontSize: "small"
    })))
  })))), selectedLogs === null || selectedLogs === void 0 ? void 0 : selectedLogs.map(l => {
    var _a;
    return /*#__PURE__*/React__default["default"].createElement(lab.TabPanel, {
      value: l
    }, /*#__PURE__*/React__default["default"].createElement(LoadingOverlay, {
      isLoading: isLogsLoading,
      showChildrenInBackground: true
    }, /*#__PURE__*/React__default["default"].createElement(reactLogViewer.LogViewer, {
      ref: logViewerRef,
      data: (_a = logText === null || logText === void 0 ? void 0 : logText[l]) === null || _a === void 0 ? void 0 : _a.text,
      hasLineNumbers: hasLineNumbers[l],
      height: 450,
      header: /*#__PURE__*/React__default["default"].createElement(HeaderComponent, null),
      onScroll: onScroll,
      toolbar: /*#__PURE__*/React__default["default"].createElement(material.Toolbar, null, /*#__PURE__*/React__default["default"].createElement(reactCore.ToolbarContent, null, /*#__PURE__*/React__default["default"].createElement(reactCore.ToolbarGroup, {
        alignment: {
          default: 'alignLeft'
        }
      }, /*#__PURE__*/React__default["default"].createElement(reactCore.ToolbarItem, null, /*#__PURE__*/React__default["default"].createElement(reactLogViewer.LogViewerSearch, {
        onChange: event => onChangeHandlerLogsSearching(event, l),
        className: "log-search-input",
        onClear: () => onClearHandlerLogsSearching(l),
        value: search[l] || '',
        placeholder: "",
        minSearchChars: 0
      }))), /*#__PURE__*/React__default["default"].createElement(reactCore.ToolbarGroup, {
        alignment: {
          default: 'alignRight'
        }
      }, /*#__PURE__*/React__default["default"].createElement(reactCore.ToolbarItem, null, /*#__PURE__*/React__default["default"].createElement(material.FormControlLabel, {
        label: "Show line numbers",
        control: /*#__PURE__*/React__default["default"].createElement(material.Switch, {
          color: "primary",
          checked: hasLineNumbers[l],
          onChange: () => toggleLineNumbers(l)
        })
      })))))
    })));
  })))));
};

const palettes = [colors.blue, colors.indigo, colors.cyan, colors.teal, colors.lightBlue, colors.green, colors.lightGreen, colors.lime, colors.yellow, colors.amber, colors.orange, colors.deepOrange, colors.red, colors.pink, colors.purple, colors.deepPurple, colors.brown, colors.grey, colors.blueGrey];
const tessellBlue = {
  dark: '#11567F',
  light: '#1E7EA1',
  hover: '#29B5E8'
};
const styles = {
  color: {
    darkShade: tessellBlue.dark,
    lightShade: tessellBlue.light,
    hover: tessellBlue.hover,
    darkBorder: '#004D73',
    lighterShade: 'rgba(30, 126, 161, 0.4)',
    lighterShade2: '#1E7EA1',
    header: '#11567F',
    baseBackground: '#FFF',
    greyBackground4: '#F7F7F7',
    greyBackground: '#EEEEEE',
    greyBackground3: '#DDDDDD',
    greyBackground2: '#CCCCCC',
    primaryBackgroundLight: '#F4F9FA',
    monotoneLightLight: '#c0c0c0',
    monotoneLightDark: '#f0f0f0',
    monotoneDarkDark: '#666666',
    monotoneDarker: '#222222',
    monotoneDarkLight: '#999999',
    red: '#EC373C',
    errorBackground: '#FFEBEB',
    warningBackground: '#FEF2D8',
    lighterRed: '#EC373CBD',
    green: '#4DAC4A',
    warn: '#F29132',
    yellow: '#FFD900',
    textBoxLabel: '#08080D',
    black: '#000'
  },
  contentBox: {
    boxSizing: 'border-box',
    borderRadius: '10px',
    boxShadow: '0px 3px 10px rgba(8, 8, 13, 0.25) !important',
    background: 'white'
  },
  textBoxLabel: {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '19px',
    color: '#08080D'
  },
  filterLabel: {
    fontStyle: 'normal',
    fontSize: '14px',
    color: '#666666'
  },
  protection: [{
    name: 'Gold',
    darkShade: '#FFD900',
    lightShade: '#FAFAD2'
  }, {
    name: 'Silver',
    darkShade: '#c0c0c0',
    lightShade: '#e8e8e8'
  }, {
    name: 'Bronze',
    darkShade: '#cd7f32',
    lightShade: '#edbd97'
  }, {
    name: 'Brass',
    darkShade: '#B5A642',
    lightShade: '#d9d19e'
  }, {
    name: 'Default',
    darkShade: tessellBlue.dark,
    lightShade: tessellBlue.light
  }],
  palettes
};

// import { styles } from './assets/scss/style-templates';
const getLogStyles = () => {
  return {
    filesDisplayBox: {
      background: styles.color.greyBackground,
      height: '100%',
      minWidth: 250
    },
    logsTab: {
      paddingLeft: '16px',
      paddingTop: '0px',
      paddingBottom: '0px',
      '&.Mui-selected': {
        backgroundColor: styles.color.greyBackground
      }
    },
    liveLogs: {
      color: styles.color.green
    },
    testss: {
      input: {
        padding: '6px 8px 6px 32px'
      }
    }
  };
};

const fileDownload = require('js-file-download');
const JSZip = require('jszip');
const Logs = _ref => {
  let {
    logFiles,
    isFilesLoading,
    entities,
    entityLabel,
    selectedEntity,
    setSelectedEntity,
    HeaderComponent,
    FilteredComponent,
    logViewerRef,
    streamLogs,
    isLogsLoading,
    currentLog,
    setCurrentLog,
    selectedLogs,
    setSelectedLogs,
    logText,
    setLogText,
    filesHeading,
    goLive,
    onScroll,
    isPollingEnabled,
    isPolling
  } = _ref;
  const classes = getLogStyles();
  const [fileSearch, setFileSearch] = React.useState('');
  const [hasLineNumbers, setHasLineNumbers] = React.useState({});
  const [logSearch, setLogSearch] = React.useState({});
  const filesToDisplay = React.useMemo(() => logFiles.filter(logFile => logFile.toLowerCase().indexOf(fileSearch.toLowerCase()) !== -1), [logFiles, fileSearch]);
  const removeFileFromViewList = name => {
    const currentIndex = selectedLogs.indexOf(name);
    const newChecked = [...selectedLogs];
    newChecked.splice(currentIndex, 1);
    setSelectedLogs(newChecked);
    if (newChecked.length) {
      setCurrentLog(newChecked[currentIndex === 0 ? 0 : currentIndex - 1]);
    } else {
      setCurrentLog(null);
    }
  };
  const addFileToViewList = name => {
    setSelectedLogs(prev => [...prev, name]);
    setCurrentLog(name);
    streamLogs(name);
    setHasLineNumbers(prev => Object.assign(Object.assign({}, prev), {
      [name]: true
    }));
  };
  React.useEffect(() => {
    if (logFiles === null || logFiles === void 0 ? void 0 : logFiles.length) {
      setLogSearch({});
      setFileSearch('');
      setHasLineNumbers({});
      setLogText === null || setLogText === void 0 ? void 0 : setLogText({});
      setSelectedLogs([]);
      addFileToViewList(logFiles[0]);
    }
  }, [logFiles]);
  const handleFileSelect = event => {
    const fileName = event.target.name;
    if (event.target.checked) {
      addFileToViewList(fileName);
    } else {
      removeFileFromViewList(fileName);
    }
  };
  const onChangeHandlerLogsSearching = React.useCallback((event, log) => {
    const searchText = event.target.value;
    setLogSearch(prev => Object.assign(Object.assign({}, prev), {
      [log]: searchText
    }));
  }, []);
  const onClearHandlerLogsSearching = React.useCallback(log => {
    setLogSearch(prev => Object.assign(Object.assign({}, prev), {
      [log]: ''
    }));
  }, []);
  const toggleLineNumbers = name => {
    setHasLineNumbers(prev => Object.assign(Object.assign({}, prev), {
      [name]: !prev[name]
    }));
  };
  function downloadFile() {
    return __awaiter(this, void 0, void 0, function* () {
      const filename = "tessell-logs-".concat(moment__default["default"]().format('YYYY_MM_DDD_HH_mm_ss'), ".zip");
      const zip = new JSZip();
      Object.keys(logText).forEach(fn => {
        if (selectedLogs.includes(fn)) {
          zip.file(fn, logText[fn].text);
        }
      });
      zip.generateAsync({
        type: 'blob'
      }).then(blob => {
        fileDownload(blob, filename);
      });
    });
  }
  return /*#__PURE__*/React__default["default"].createElement(LoadingOverlay, {
    isLoading: isFilesLoading
  }, /*#__PURE__*/React__default["default"].createElement(material.Box, {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    direction: "row",
    height: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(LogsListAndSearch, {
    fileSearch: fileSearch,
    setFileSearch: setFileSearch,
    filesToDisplay: filesToDisplay,
    selectedLogs: selectedLogs,
    handleFileSelect: handleFileSelect,
    classes: classes,
    filesHeading: filesHeading
  }), /*#__PURE__*/React__default["default"].createElement(LogsView, {
    selectedLogs: selectedLogs,
    logFiles: logFiles,
    currentLog: currentLog,
    setCurrentLog: setCurrentLog,
    removeFileFromViewList: removeFileFromViewList,
    isLogsLoading: isLogsLoading,
    logViewerRef: logViewerRef,
    logText: logText,
    hasLineNumbers: hasLineNumbers,
    search: logSearch,
    toggleLineNumbers: toggleLineNumbers,
    entities: entities,
    entityLabel: entityLabel,
    selectedEntity: selectedEntity,
    setSelectedEntity: setSelectedEntity,
    downloadFile: downloadFile,
    goLive: goLive,
    onScroll: onScroll,
    isPollingEnabled: isPollingEnabled,
    isPolling: isPolling,
    // * ---- components ---
    HeaderComponent: HeaderComponent,
    FilteredComponent: FilteredComponent,
    // * helper fns
    onChangeHandlerLogsSearching: onChangeHandlerLogsSearching,
    onClearHandlerLogsSearching: onClearHandlerLogsSearching,
    classes: classes
  }))));
};

const useStyles = () => {
  const theme = material.useTheme();
  return {
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    },
    progress: {
      color: 'white'
    },
    userInput: {
      marginBottom: theme.spacing(2)
    },
    input: {
      marginTop: theme.spacing(2)
    },
    vInput: {
      margin: '10px'
    },
    backButton: {
      alignSelf: 'self-start',
      marginLeft: -1.25
    },
    personaBox: {
      height: '300px',
      width: '300px',
      padding: theme.spacing(1),
      margin: theme.spacing(1),
      overflow: 'auto'
    },
    featureBox: {
      borderRadius: '15px',
      backgroundColor: '#8996DF33',
      transition: 'background-color 200ms linear',
      '&:hover': {
        backgroundColor: '#8996DF77'
      }
    },
    filterBox: {
      width: 200
    },
    slaBox: {
      height: 200,
      width: 300,
      padding: theme.spacing(1),
      margin: theme.spacing(1)
    },
    addIcon: {
      fontSize: '64px'
    },
    protectionIcon: {
      width: 32,
      marginRight: theme.spacing(1)
    },
    appIcon: {
      width: '32px'
    },
    personaIcon: {
      height: '100px'
    },
    featureIcon: {
      fontSize: '32px'
    },
    appPlus: {
      fontSize: '12px'
    },
    selectedTreeItem: {
      backgroundColor: 'transparent !important'
    },
    avatar: {
      backgroundColor: styles.color.lightShade,
      width: theme.spacing(10),
      height: theme.spacing(10)
    },
    list: {
      width: '100%',
      maxWidth: 360,
      bgcolor: 'background.paper'
    },
    deleteModalContent: {
      marginTop: 1
    },
    tree: {
      minWidth: 300
    },
    button: {
      marginRight: theme.spacing(1)
    },
    roundedBtn: {
      marginRight: theme.spacing(1),
      borderRadius: 20
    },
    reset: {
      width: '100%',
      height: '100%',
      background: '#E6E9FF'
    },
    cancel: {
      width: '10%'
    },
    error: {
      color: 'red'
    },
    tessellLogo: {
      width: '5%',
      height: '5%',
      mx: 'auto',
      my: '-2%',
      border: '10% solid #f0f0f0',
      borderRadius: '50%',
      background: '#E6E9FF',
      zIndex: 'tooltip'
    },
    form: {
      width: '30%',
      border: '1px solid #f0f0f0',
      borderRadius: '3%',
      mx: 'auto',
      background: '#E6E9FF'
    },
    login: {
      width: '150px'
    },
    link: {
      textDecoration: 'inherit'
    },
    userInput60: {
      margin: theme.spacing(1),
      width: '60%'
    },
    filter: {
      width: 250,
      '& .MuiOutlinedInput-root': {
        borderRadius: '20px'
      },
      '& .MuiFilledInput-root': {
        borderRadius: '24px'
      }
    }
  };
};

const RequiredIndication = () => {
  return /*#__PURE__*/React__default["default"].createElement(material.Typography, {
    sx: Object.assign(Object.assign({}, styles.textBoxLabel), {
      color: styles.color.red
    })
  }, "\u00A0*");
};

const useTessellInputStyles = styles$1.makeStyles(() => {
  return {
    inputLabel: _ref => {
      let {
        labelStyles,
        disabled
      } = _ref;
      const styleObj = Object.assign(Object.assign(Object.assign({}, styles.textBoxLabel), labelStyles), {
        width: 'fit-content',
        marginBottom: 4
      });
      if (disabled) {
        styleObj.color = styles.color.monotoneDarkLight;
      }
      return styleObj;
    }
  };
});

const TessellInput = props => {
  const {
      containerStyles = {},
      label,
      labelStyles = {},
      width = 'auto',
      variant = 'outlined',
      disabled,
      shouldAutoFocus = false,
      rows,
      markAsRequired = false
    } = props,
    textFieldProps = __rest(props, ["containerStyles", "label", "labelStyles", "width", "variant", "disabled", "shouldAutoFocus", "rows", "markAsRequired"]);
  const classes = useTessellInputStyles(props);
  return /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    width: width,
    sx: containerStyles
  }, /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    direction: 'row'
  }, /*#__PURE__*/React__default["default"].createElement(material.Typography, {
    className: classes.inputLabel
  }, label), markAsRequired && /*#__PURE__*/React__default["default"].createElement(RequiredIndication, null)), /*#__PURE__*/React__default["default"].createElement(material.TextField, Object.assign({
    variant: variant,
    disabled: disabled,
    autoFocus: shouldAutoFocus,
    multiline: rows > 1,
    rows: rows
  }, textFieldProps)));
};

const TessellModal = props => {
  const {
      customStyles = {},
      renderComponents,
      maxWidth,
      open,
      onClose
    } = props,
    restProps = __rest(props, ["customStyles", "renderComponents", "maxWidth", "open", "onClose"]);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, open && ( /*#__PURE__*/React__default["default"].createElement(material.Dialog, Object.assign({
    open: open,
    onClose: onClose,
    maxWidth: maxWidth
  }, restProps), /*#__PURE__*/React__default["default"].createElement(material.DialogTitle, {
    sx: customStyles === null || customStyles === void 0 ? void 0 : customStyles.title
  }, (renderComponents === null || renderComponents === void 0 ? void 0 : renderComponents.title) && ( /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(material.Stack, null, renderComponents.title)))), (renderComponents === null || renderComponents === void 0 ? void 0 : renderComponents.content) ? ( /*#__PURE__*/React__default["default"].createElement(material.DialogContent, {
    sx: customStyles === null || customStyles === void 0 ? void 0 : customStyles.content
  }, renderComponents.content)) : '', renderComponents.actions ? ( /*#__PURE__*/React__default["default"].createElement(material.DialogActions, {
    sx: customStyles === null || customStyles === void 0 ? void 0 : customStyles.actions
  }, renderComponents === null || renderComponents === void 0 ? void 0 : renderComponents.actions)) : '')));
};

/* eslint-disable max-len */
function ConfirmationDialog(_ref) {
  let {
    open,
    setOpen,
    handleConfirm,
    confirmContent,
    title,
    cancelBtnText,
    confirmBtnText,
    isLoading,
    isCommentRequired = false
  } = _ref;
  const classes = useStyles();
  const [comment, setComment] = React.useState('');
  const DialogTitle = React.useMemo(() => /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, title || 'Confirmation'), [title]);
  const DialogContent = React.useMemo(() => ( /*#__PURE__*/React__default["default"].createElement(material.DialogContentText, {
    id: "alert-dialog-description"
  }, confirmContent || 'Are you sure you want to confirm?', isCommentRequired && ( /*#__PURE__*/React__default["default"].createElement(TessellInput, {
    label: "Reason",
    variant: "outlined",
    size: "small",
    name: "reason",
    onChange: e => {
      var _a;
      setComment((_a = e.target.value) === null || _a === void 0 ? void 0 : _a.trim());
    },
    rows: 3
  })))), [confirmContent, isCommentRequired]);
  const DialogActions = React.useMemo(() => ( /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    width: "100%",
    direction: "row",
    justifyContent: "flex-start",
    mt: 2
  }, /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    spacing: 1,
    direction: "row",
    justifyContent: "flex-end",
    width: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(material.Button, {
    onClick: () => {
      setOpen(false);
    },
    variant: "outlined",
    size: "small",
    sx: classes.roundedBtn
  }, cancelBtnText || 'Cancel'), /*#__PURE__*/React__default["default"].createElement(lab.LoadingButton, {
    onClick: () => {
      handleConfirm(comment);
    },
    color: "primary",
    size: "small",
    variant: "contained",
    loading: isLoading,
    disabled: isCommentRequired ? !Boolean(comment) : false
  }, confirmBtnText || 'Confirm')))), [cancelBtnText, confirmBtnText, isCommentRequired, isLoading, comment]);
  const renderComponents = {
    title: DialogTitle,
    content: DialogContent,
    actions: DialogActions
  };
  const customStyles = {
    title: {},
    content: classes.deleteModalContent,
    actions: {}
  };
  return /*#__PURE__*/React__default["default"].createElement(TessellModal, {
    customStyles: customStyles,
    renderComponents: renderComponents,
    maxWidth: "sm",
    open: open,
    onClose: () => setOpen(false)
  });
}

const ITEM_HEIGHT = 48;
const ThreeDotMenu = _ref => {
  let {
    options,
    handleOnSelect
  } = _ref;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(material.IconButton, {
    "aria-label": "more",
    id: "long-button",
    "aria-controls": open ? 'long-menu' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "true",
    onClick: handleClick
  }, /*#__PURE__*/React__default["default"].createElement(MoreVertIcon__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(material.Menu, {
    id: "long-menu",
    MenuListProps: {
      'aria-labelledby': 'long-button'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5,
        width: '20ch'
      }
    }
  }, options.map(option => ( /*#__PURE__*/React__default["default"].createElement(material.MenuItem, {
    key: option,
    onClick: () => {
      handleOnSelect(option);
      handleClose();
    }
  }, option)))));
};

const useTessellDrawerStyles = () => {
  const theme = material.useTheme();
  return {
    drawer: {
      flex: '1 1 auto',
      width: '100%',
      zIndex: theme.zIndex.drawer + 5
    }
  };
};

const TessellDrawer = props => {
  const {
    children,
    open,
    onCloseDrawer
  } = props;
  const classes = useTessellDrawerStyles();
  return /*#__PURE__*/React__default["default"].createElement(material.Drawer, {
    anchor: "right",
    open: open,
    onClose: onCloseDrawer,
    sx: classes.drawer
  }, children);
};

const TessellSelect = props => {
  const {
      containerStyles = {},
      label,
      labelStyles = {},
      options,
      width = 'auto',
      variant = 'outlined',
      disabled,
      shouldAutoFocus = false,
      rows,
      markAsRequired = false
    } = props,
    textFieldProps = __rest(props, ["containerStyles", "label", "labelStyles", "options", "width", "variant", "disabled", "shouldAutoFocus", "rows", "markAsRequired"]);
  const classes = useTessellInputStyles(props);
  return /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    width: width,
    sx: containerStyles
  }, /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    direction: 'row'
  }, /*#__PURE__*/React__default["default"].createElement(material.Typography, {
    className: classes.inputLabel,
    mb: 1
  }, label), markAsRequired && /*#__PURE__*/React__default["default"].createElement(RequiredIndication, null)), /*#__PURE__*/React__default["default"].createElement(material.TextField, Object.assign({
    select: true,
    variant: variant,
    disabled: disabled
  }, textFieldProps), options));
};

const useDetailsModalStyles = () => {
  return {
    title: {
      width: 400
    },
    closeIcon: {
      cursor: 'pointer',
      color: '#666666'
    },
    contentBox: {
      pt: 2
    },
    field: {
      py: '12px',
      alignItems: 'center'
    },
    fieldLabel: {
      pr: 1,
      width: 150
    },
    fieldValue: {
      width: 250
    }
  };
};

const DetailsModal = _ref => {
  let {
    open,
    setOpen,
    fields
  } = _ref;
  const classes = useDetailsModalStyles();
  const DialogTitle = React.useMemo(() => ( /*#__PURE__*/React__default["default"].createElement(material.Stack, {
    direction: 'row',
    justifyContent: "space-between",
    alignItems: 'center',
    sx: classes.title
  }, "Details", /*#__PURE__*/React__default["default"].createElement(iconsMaterial.Close, {
    sx: classes.closeIcon,
    onClick: () => setOpen(false)
  }))), []);
  const DialogContent = React.useMemo(() => ( /*#__PURE__*/React__default["default"].createElement(material.DialogContentText, {
    sx: classes.contentBox
  }, fields === null || fields === void 0 ? void 0 : fields.map((_field, index) => {
    var _a;
    return !((_a = _field === null || _field === void 0 ? void 0 : _field.isHidden) === null || _a === void 0 ? void 0 : _a.call(_field)) && ( /*#__PURE__*/React__default["default"].createElement(material.Stack, {
      direction: "row",
      borderTop: index !== 0 ? '1px solid #E6E6E6' : '',
      sx: classes.field
    }, /*#__PURE__*/React__default["default"].createElement(material.Typography, {
      sx: classes.fieldLabel
    }, _field.label), /*#__PURE__*/React__default["default"].createElement(material.Typography, {
      sx: classes.fieldValue
    }, _field.value)));
  }))), [fields]);
  const renderComponents = {
    title: DialogTitle,
    content: DialogContent
  };
  const customStyles = {
    title: {},
    content: {},
    actions: {}
  };
  return /*#__PURE__*/React__default["default"].createElement(TessellModal, {
    customStyles: customStyles,
    renderComponents: renderComponents,
    maxWidth: "sm",
    open: open,
    onClose: () => setOpen(false)
  });
};

exports.Button = Button;
exports.ConfirmationDialog = ConfirmationDialog;
exports.DetailsModal = DetailsModal;
exports.HelloWorld = HelloWorld;
exports.Logs = Logs;
exports.TessellDrawer = TessellDrawer;
exports.TessellInput = TessellInput;
exports.TessellModal = TessellModal;
exports.TessellSelect = TessellSelect;
exports.ThreeDotMenu = ThreeDotMenu;
